import React from 'react';
interface PageLayoutProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  icon?: React.ReactNode;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
  background?: 'white' | 'slate';
  noPadding?: boolean;
}
export function PageLayout({
  children,
  title,
  subtitle,
  icon,
  maxWidth = 'xl',
  background = 'slate',
  noPadding = false
}: PageLayoutProps) {
  const maxWidthClasses = {
    sm: 'max-w-2xl',
    md: 'max-w-4xl',
    lg: 'max-w-5xl',
    xl: 'max-w-6xl',
    '2xl': 'max-w-7xl',
    full: 'max-w-full'
  };
  const bgClasses = {
    white: 'bg-white',
    slate: 'bg-slate-50'
  };
  return <div className={`min-h-screen ${bgClasses[background]} pt-20`} data-id="element-207">
      {/* Page Header */}
      {(title || subtitle || icon) && <div className="bg-white border-b border-slate-200" data-id="element-208">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16" data-id="element-209">
            <div className={`${maxWidthClasses[maxWidth]} mx-auto text-center`} data-id="element-210">
              {icon && <div className="inline-flex items-center justify-center w-16 h-16 bg-primary-50 rounded-2xl mb-6 shadow-sm" data-id="element-211">
                  {icon}
                </div>}
              {title && <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-primary-900 mb-4 tracking-tight" data-id="element-212">
                  {title}
                </h1>}
              {subtitle && <p className="text-lg sm:text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed" data-id="element-213">
                  {subtitle}
                </p>}
            </div>
          </div>
        </div>}

      {/* Page Content */}
      <div className={noPadding ? '' : 'container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16'} data-id="element-214">
        <div className={`${maxWidthClasses[maxWidth]} mx-auto`} data-id="element-215">{children}</div>
      </div>
    </div>;
}